<template>
	<basic-skeleton-loader v-if="!article" />

	<base-container v-else-if="typeof article === 'object' && article.length === 0">
		<p>No content was found for this page</p>
	</base-container>

	<base-container v-else>
		<component :is="articleType(article.type)" :article="article" />
	</base-container>
</template>

<script setup>
import { ref } from 'vue'
import { useApi } from '@/composables/useApi'
import { articleTypes } from '@/config/componentMap'
import BasicSkeletonLoader from '@/components/layout/skeleton/BasicSkeletonLoader.vue'
import BaseContainer from '@/components/layout/base/BaseContainer.vue'

const props = defineProps({
  page: {
    type: Object,
    required: true
  }
})

const { api } = useApi()

const article = ref(null)

function articleType(type) {
  return articleTypes[type]
}

api({
  url: props.page.type === 'post' ?  `/content/${props.page.id}` : `/content/${props.page.id}/${props.page.slug}`,
  callback: data => {
    article.value = props.page.type === 'post' ? data[0] : data
  },
  errorCallback: () => {
    article.value = null
    console.error('Error when requesting content')
  }
})
</script>
